module.exports = __webpack_public_path__ + "img/Accesspark_logo_square_txt.7f2bbf15.png";